<h2 mat-dialog-title>{{ title || 'Choose connector' }}</h2>
<div mat-dialog-content class="dialog-content">
  @for (connector of connectors; track connector) {
    <div
      class="mb-2 flex min-w-[300px] items-center rounded-2xl border-[1px] border-solid border-current p-4 hover:cursor-pointer hover:bg-green-950 hover:text-white"
      (click)="chooseConnector(connector)">
      <div class="mr-2">
        <i class="con-{{ connector.ConnectorTypes[0].IconName }} align-middle point-icon text-2xl"></i>
      </div>
      <div>
        <div>
          @if (OcppVersion === VERSION_16) {
            {{ 'POINT_ID' | translate }} {{ connector.EvseNumber }}
          } @else if (OcppVersion === VERSION_201 || OcppVersion === VERSION_21) {
            {{ 'EVSE_ID' | translate }} {{ connector.EvseNumber }} - {{ 'POINT_ID' | translate }}
            {{ connector.ConnectorID }}
          }
        </div>
      </div>
    </div>
  }
  <div class="mt-4">
    <h3 class="manual-heading">{{ 'or choose manually' }}</h3>
    <div>
      <mat-form-field class="w-full">
        <mat-label>{{ getEVSENameByOcppVersion() | translate }}</mat-label>
        <input matInput autofocus="false" type="number" [(ngModel)]="manual.evseID" name="EVSE_ID" />
      </mat-form-field>
    </div>
    @if (OcppVersion == VERSION_201 || OcppVersion == VERSION_21) {
      <div>
        <mat-form-field class="w-full">
          <mat-label>{{ 'CONNECTOR_ID' | translate }}</mat-label>
          <input matInput type="number" [(ngModel)]="manual.connectorID" name="CONNECTOR_ID" />
        </mat-form-field>
      </div>
    }
  </div>
  @if (inputs?.length) {
    <div class="mt-4">
      <form [formGroup]="pointsForm" #pointsFormRef="ngForm" (ngSubmit)="handleSubmit()" novalidate>
        <h3 class="manual-heading">{{ 'SET_PARAMETERS' | translate }}</h3>
        <div>
          @for (item of inputs; track item) {
            @if (!item.visibleFn || item.visibleFn(pointsForm.value)) {
              @if (item.type === 'text' || item.type === 'number') {
                <div>
                  <mat-form-field class="w-full" floatLabel="auto">
                    <mat-label>{{ item.placeholder }}</mat-label>
                    <input matInput [type]="item.type" [formControlName]="item.name" />
                    @if (item.required) {
                      <mat-error>
                        {{ 'REQUIRED' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                  @if (item.name === 'idTag' || item.name === 'parentIdTag') {
                    <div class="mb-2">
                      @for (token of item?.data?.tokens || []; track token) {
                        <span
                          (click)="fillValue(item.name, token.value)"
                          class="mr-2 cursor-pointer text-sm text-cyan-500 hover:text-cyan-900">
                          {{ token.name }}
                        </span>
                      }
                    </div>
                  }
                </div>
              }
              @if (item.type === 'datetime-local') {
                <mat-form-field class="w-full">
                  <mat-label>{{ item.placeholder }}</mat-label>
                  <input
                    matInput
                    [required]="item.required"
                    [name]="item.name"
                    [type]="item.type"
                    [formControlName]="item.name" />
                </mat-form-field>
              }
              @if (item.type === 'select') {
                <mat-form-field class="w-full">
                  <mat-label>{{ item.placeholder }}</mat-label>
                  <mat-select [formControlName]="item.name" [required]="item.required">
                    @for (item of item.options; track item) {
                      <mat-option [value]="item">
                        {{ item }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (item.required) {
                    <mat-error>
                      {{ 'REQUIRED' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            }
          }
        </div>
      </form>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="sendEvseAndConnector()">
    {{ 'OK' | translate }}
  </button>
  <button mat-raised-button (click)="this.dialogRef.close()" type="button">
    {{ 'CANCEL' | translate }}
  </button>
</div>
